import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTrainingByQuery } from './TrainingCrud';
import { useSelector } from "react-redux";
import _ from "lodash";

//
const initialState = {
    loading: 'idle',
    trainings: [],
    totalCount: 0,
    error: null,
    queryParams: {
        page: 1,
        sizePerPage: 50000,
        standardType: "",
        status: false,
    }
}

export const fetchTrainingByUserId = createAsyncThunk(
    'traininguser/fetchTrainingByUserId',
    async ( userId, { rejectWithValue, getState } ) => {
        const { queryParams } = getState().training;
        //console.log(queryParams)
        let filter;
        if (queryParams.status) {
            filter = {
                userId: userId,
                status: queryParams.status,
                standard:
                {
                    version: { gt : 0}
                    /*status: {
                        in: ['Official', 'Deleted','StandBy']
                    }*/
                }
            }
        }
        else {
            filter = {
                userId: userId,
                status: queryParams.status,
                standard:
                {
                    version: { gt: 0 }
                    //status: "Official"
                }
            }
        }
        if ( ! _.isEmpty(queryParams.standardType) ) {
            filter.standard = {
                standardType: queryParams.standardType
            }
        }
        const response = await fetchTrainingByQuery({
            filter: filter,
            skip: ( queryParams.page - 1 ) * queryParams.sizePerPage,
            top: queryParams.sizePerPage,
            count: true,
        });

        if (response.status !== 200) {
            return rejectWithValue(response.statusText);
        }

        return {
            trainings: response.data.value,
            total: response.data['_count']
        };
    }
);

export const trainingSlice = createSlice({
    name: 'training',
    initialState,
    reducers: {
        gotoPage: ( state, action ) => {
            state.queryParams.page = action.payload;
        },
        changeItemsPerPage: ( state, action ) => {
            state.queryParams.sizePerPage = action.payload;
        },
        changeQuery: ( state, action ) => {
            state.queryParams.sizePerPage = action.payload.sizePerPage;
            state.queryParams.page = action.payload.page;
        },
        changeFilters: ( state, action ) => {
            state.queryParams.standardType = action.payload.standardType
            state.queryParams.status = action.payload.status
        }
    },
    extraReducers: (build) => {
        build.addCase(fetchTrainingByUserId.pending, (state, { payload }) => {
            if ( state.loading === 'idle' ) {
                state.loading = 'loading';
            }
        }).addCase(fetchTrainingByUserId.fulfilled, (state, { payload }) => {
            if ( state.loading === 'loading' ) {
                state.loading = 'idle';
                state.trainings = payload.trainings;
                state.totalCount = payload.total;
            }
        }).addCase(fetchTrainingByUserId.rejected, (state, action) => {
            state.loading = 'idle';
            if ( action.payload ) {
                state.error = action.payload;
            } else {
                state.error = action.error;
            }
        })
    }
});

// Export actions
export const { gotoPage, changeItemsPerPage, changeQuery, changeFilters } = trainingSlice.actions;

//
export const useTraining = () => useSelector(( state ) => state.training );

// Export reducer
export default trainingSlice.reducer;